module.exports = __webpack_public_path__ + "static/media/dog-one.209f86de.jpg";